export const kInsertions = Symbol('orama.insertions');
export const kRemovals = Symbol('orama.removals');

//# sourceMappingURL=types.js.map